var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.showCopyright)?_c('Copyright'):_vm._e(),_c('ScrollTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }